const colors = ['#FFA7A7', '#FFB88C', '#FFD89C', '#D7E08A', '#A3C585'];
export function StatisticColorByStepCalc({ max, score }: { max: number; score: number }) {
  if (max === 0) return colors[0];
  const percents = Math.floor((score / max) * 100);
  if (percents >= 0 && percents <= 19) return colors[0];
  if (percents >= 20 && percents <= 39) return colors[1];
  if (percents >= 40 && percents <= 59) return colors[2];
  if (percents >= 60 && percents <= 79) return colors[3];
  if (percents >= 80 && percents <= 100) return colors[4];
  if (percents > 100) return colors[4];
  return '#2987CC';
}
